const EmailIcon = ({ size = 20 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M3 4a2 2 0 0 0-2 2v1.161l8.441 4.221a1.25 1.25 0 0 0 1.118 0L19 7.162V6a2 2 0 0 0-2-2H3Z" />
        <path d="M19 8.839l-7.77 3.885a2.75 2.75 0 0 1-2.46 0L1 8.839V14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.839Z" />
    </svg>
);

const EmailLoginButton = ({ onClick }) => {
    return (
        <div
            onClick={onClick}
            style={{
                display: "flex",
                height: "56px",
                padding: "8px 0px",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                alignSelf: "stretch",
                background: "#3D3D57",
                borderRadius: "12px",
                cursor: "pointer",
            }}
        >
            <EmailIcon />
            <span
                style={{
                    color: "#FFFFFF",
                    fontFamily: "Pretendard",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "100%",
                    letterSpacing: "-0.6px",
                }}
            >
                이메일로 시작하기
            </span>
        </div>
    );
};

export default EmailLoginButton;
